import { render, staticRenderFns } from "./Keuzemenu.vue?vue&type=template&id=0e24b81a&scoped=true&"
import script from "./Keuzemenu.vue?vue&type=script&lang=js&"
export * from "./Keuzemenu.vue?vue&type=script&lang=js&"
import style0 from "./Keuzemenu.vue?vue&type=style&index=0&id=0e24b81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e24b81a",
  null
  
)

export default component.exports